<template>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：税務署一覧画面(STDSDC01C11)                                                                     _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
  <div v-bind="$attrs" class="frm-row" >
    <span class="frm-label w-150px">
      <strong>所轄税務署</strong>
    </span>
    <span class="frm-label w-45px" v-show="props.isChangeWidth"></span>
    <input
      type="text"
      id="taxOfficeName"
      class="frm-text frm-size-modelValue"
      style="width: 695px"
      maxlength="30"
      v-model="inputTaxOfficeName"
      :class="{ error: errorData.isErrorCompetentTaxOffice }"
      :tabindex="tabindex"
      @input="inputValChange(inputTaxOfficeName)"
    />　税務署
    <button
      class="frm-btn strong"
      data-role="popup-open"
      data-target="#popup-MainUser"
      :tabindex="tabindex + 1"
      @click="showModal"
    >
      参照
    </button>
  </div>
  <p
    class="errMsg"
    :style="{ 'margin-left': props.isChangeWidth ? '215px' : '160px' }"
    v-show="errorData.errors_CompetentTaxOffice != ''"
  >
    <ErrorMessageCase
      :errors="errorData.errors_CompetentTaxOffice"
    ></ErrorMessageCase>
  </p>
  <BaseModal :show="isShow">
    <div class="popup" style="width: 1000px">
      <div class="popup-head">税務署一覧</div>
      <div class="popup-body blue">
        <!--
          ****  メッセージ表示領域 ****
          -->
        <p
          id="outMessageArea"
          class="errMsg title-ico ico-warning mb-5"
          v-show="errors.length > 0"
        >
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <h3>税務署を選択してください。</h3>
        <div class="swap-row">
          <div class="swap-left" style="width: 300px">
            <div class="frm-row">
              <span class="frm-label">都道府県</span>
              <select
                class="frm-select frm-size-s"
                :class="prefecture ? 'setvalue' : ''"
                v-model="prefecture"
                ref="prefectureSelect"
                @change="selectOfficeByName(prefecture, '')"
              >
                <option
                  v-for="item in prefectureData"
                  :key="item.code"
                  :value="item.code"
                  :class="prefecture == item.name ? 'setvalue' : 'not-setvalue'"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="frm-row">
              <div
                class="frm-search frm-size-xl"
                :class="searchKey ? 'setvalue' : ''"
              >
                <span class="frm-label">
                  &nbsp;<img src="../assets/images/TDSDC/icon_search.png" />
                </span>
                <input
                  type="search"
                  class="frm-search-text"
                  placeholder="検索キーワード"
                  maxlength="255"
                  v-model="searchKey"
                />
              </div>
            </div>
            <!-- table -->
            <div class="alignright">
              <p>{{ displayedResults }}</p>
            </div>
            <div class="table-wrap" style="margin-top: 0px">
              <div class="table-scroll-header">
                <table class="table-select single-select scroll">
                  <colgroup>
                    <col style="width: 40px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="sort hover" @click="sortData('name')">
                        税務署一覧
                        <div class="sort-toggle">
                          <button
                            class="sort-toggle-asc"
                            :class="
                              sort.key == 'name' && sort.isAsc ? 'on' : ''
                            "
                            type="button"
                          >
                            asc
                          </button>
                          <button
                            class="sort-toggle-desc"
                            :class="
                              sort.key == 'name' && !sort.isAsc ? 'on' : ''
                            "
                            type="button"
                          >
                            desc
                          </button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div
                class="table-scroll-body"
                style="height: 250px; background-color: #ffffff"
              >
                <table
                  class="table-select single-select scroll"
                  style="width: 100%; table-layout: fixed"
                >
                  <colgroup>
                    <col style="width: 40px" />
                  </colgroup>
                  <tbody id="officeList">
                    <tr
                      v-for="taxOffice in displayTaxOfficeData"
                      :id="taxOffice.name"
                      :key="taxOffice.name"
                      :class="
                        taxOffice.name == selectedTaxOfficeInfo.name
                          ? 'selected'
                          : ''
                      "
                      @click="selectTaxOffice(taxOffice, 'click')"
                    >
                      <td>{{ taxOffice.name }}</td>
                    </tr>
                  </tbody>
                </table>
                <table class="table-select single-select" v-show="noDataFlag">
                  <tbody>
                    <tr>
                      <p class="noData-area">
                        {{ Common.getMessage("MTCL1118", ["税務署"]) }}
                      </p>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="swap-center"></div>
          <div class="swap-right" style="width: 500px">
            <div class="frm-row">
              <h3>詳細情報</h3>
            </div>
            <div class="frm-row">
              <span class="frm-label w-100px">
                <strong>名称</strong>
              </span>
              <span
                >{{ selectedTaxOfficeInfo.name }} <br />{{
                  spliceBrackets(selectedTaxOfficeInfo.nameF)
                }}
              </span>
            </div>
            <div class="frm-row">
              <span class="frm-label w-100px">
                <strong>郵便番号</strong>
              </span>
              <span>{{ selectedTaxOfficeInfo.zipCode }}</span>
            </div>
            <div class="frm-row">
              <span class="frm-label w-100px">
                <strong>住所</strong>
              </span>
              <span>{{ selectedTaxOfficeInfo.address }}</span>
            </div>
            <div class="frm-row">
              <span class="frm-label w-100px">
                <strong>電話番号</strong>
              </span>
              <span>{{ selectedTaxOfficeInfo.telNumber }}</span>
            </div>
            <div class="frm-row">
              <span class="frm-label w-100px">
                <strong>管轄地域</strong>
              </span>
              <div class="frm-item">
                <textarea
                  class="frm-text"
                  style="width: 420px"
                  rows="4"
                  v-model="selectedTaxOfficeInfo.jurisdiction"
                  disabled
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              data-role="popup-close"
              @click="oKButtonClick"
            >
              確定
            </button>
            <button
              class="frm-btn large"
              data-role="popup-close"
              @click="cancelButtonClick"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import Common from "@/util/common.js";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import Validation from "@/util/validation.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import BaseModal from "@/components/Base/BaseModal.vue";
import {
  ref,
  computed,
  defineProps,
  defineEmits,
  reactive,
  useAttrs,
  nextTick,
  watch,
  defineExpose,
} from "vue";
import {
  API_DisplayDepartmentListReferenceModal,
  API_ChangePrefecture,
} from "@/api/Modules/DC01/STDSDC01C11";
import { useStore } from "vuex";
const { commit } = useStore();
const attrs = useAttrs();

// **********************************************
// #region 変数定義
// **********************************************
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
    default: "",
  },
  tabindex: {
    type: Number,
    default: 0,
  },
  isChangeWidth: {
    type: Boolean,
    default: false,
  },
});
const isShow = ref(false);
// **********************************************
//エラーメッセージ
// **********************************************
const errorData = reactive({
  isErrorCompetentTaxOffice: false, // 所轄税務署_エラー表示
  errors_CompetentTaxOffice: [], // エラー情報_所轄税務署
});
// NoData Flag
const noDataFlag = computed(() => {
  return displayTaxOfficeData.value.length === 0;
});
const inputTaxOfficeName = ref(props.modelValue); //InputBox表示用
const taxOfficeName = ref(""); //子画面詳細表示用
const errors = ref([]);
const searchKey = ref("");
// const emit = defineEmits("showModal");
const sort = reactive({
  key: "", // ソートキー
  isAsc: false, // 昇順ならtrue,降順ならfalse
});
const sortData = (key) => {
  Common.sortData2(sort, key);
};
const prefecture = ref(1);
const prefectureData = ref([]);
const taxOfficeData = ref([]);
const selectedTaxOfficeInfo = ref({
  taxOfficeName: "",
  taxOfficeNameF: "",
  zipCode: "",
  address: "",
  telNumber: "",
  jurisdiction: "",
});
// #endregion

// **********************************************
//#region　計算
// **********************************************
// 表示用データリスト
const displayTaxOfficeData = computed(() => {
  let filterList = taxOfficeData.value
    ? taxOfficeData.value.filter((item) => item.name.includes(searchKey.value))
    : [];

  let sortedList = Common.listSort2(sort.key, sort.isAsc, filterList);

  return sortedList;
});

// 件数
const displayedResults = computed(() => {
  return searchKey.value
    ? `${displayTaxOfficeData.value.length}/${taxOfficeData.value.length}件`
    : `${taxOfficeData.value.length}件`;
});

// 所轄税務署値の非空判断
const checkCompetentTaxOffice = computed(() => {
  return inputTaxOfficeName.value ? inputTaxOfficeName.value : "";
});
// #endregion

// **********************************************
// #region 関数
// **********************************************

// 選択データ
const selectTaxOffice = (item, type) => {
  taxOfficeName.value = item.name;
  selectedTaxOfficeInfo.value = item;
  nextTick(() => {
    if (type !== "click") {
      const officeListDom = document.querySelector("#officeList");
      const selectdOffice = officeListDom.querySelector(".selected");
      selectdOffice.scrollIntoView();
    }
  });
};

//　かっこを付ける
const spliceBrackets = (item) => {
  if (item) {
    const rtnValue = "（" + item + "）";
    return rtnValue;
  }
};

const emit = defineEmits(["confirm", "cancel", "update:modelValue"]);
// 「確定」ボタン押下処理
const oKButtonClick = () => {
  errors.value = [];
  if (noDataFlag.value) {
    errors.value.push(
      Common.createError("MTCL1034", Common.getMessage("MTCL1034", ["税務署"]))
    );
    return;
  }
  inputTaxOfficeName.value =
    taxOfficeName.value.substring(taxOfficeName.value.length - 3) == "税務署"
      ? String(taxOfficeName.value).replace("税務署", "")
      : taxOfficeName.value;
  emit("update:modelValue", inputTaxOfficeName.value);
  isShow.value = false;
  //エラー表示の初期化
  errorStyleInit();
};

// 「キャンセル」ボタン押下処理
const cancelButtonClick = () => {
  emit("cancel");
  isShow.value = false;
};

const selectOfficeByName = async (prefectureCode, officeName) => {
  commit("businessModule/processDialogue", true);
  // const target = prefectureData.value?.find((e) => (e.code = prefectureCode));
  prefecture.value = prefectureCode;

  const response = await API_ChangePrefecture({
    prefectureCode: prefecture.value,
  });
  if (response.result === "0000") {
    taxOfficeData.value = response.taxOfficeData;
    if (officeName) {
      const target = response.taxOfficeData.find(
        (item) => item.name === officeName
      );
      if (target) {
        // ・一致するデータ有り：「都道府県」ドロップダウンを設定し、該当の税務署を選択状態にする。
        selectTaxOffice(target);
      } else if (!target && taxOfficeData.value.length > 0) {
        // ・一致するデータ無し：「北海道」を「都道府県」ドロップダウンに設定し、「税務署一覧」の先頭行を選択状態にする。
        selectTaxOffice(taxOfficeData.value[0]);
      }
    } else if (!officeName && taxOfficeData.value.length > 0) {
      // 「税務署一覧」の先頭行を選択状態にする。
      selectTaxOffice(taxOfficeData.value[0]);
    }
  }
  commit("businessModule/processDialogue", false);
};
//一覧データを取得
const getList = () => {
  commit("businessModule/processDialogue", true);
  let competentTaxOffice = inputTaxOfficeName.value || "";
  // 半角カタカナが含まれている場合、全角カタカナに変換する。
  competentTaxOffice = Common.halfWidth2FullWidthKana(
    Common.removeSpaces(competentTaxOffice)
  );
  if (competentTaxOffice && !competentTaxOffice.endsWith("税務署")) {
    competentTaxOffice += "税務署";
  }
  const params = {
    address: attrs.address,
    competentTaxOffice: inputTaxOfficeName.value,
  };
  return API_DisplayDepartmentListReferenceModal(params)
    .then((response) => {
      if (response.result == "0000") {
        prefectureData.value = response.prefectureData;
        taxOfficeData.value = response.taxOfficeData;

        if (response.competentTaxOffice && taxOfficeData.value.length > 0) {
          selectOfficeByName(
            taxOfficeData.value[0].prefectureCode,
            competentTaxOffice
          );
        } else if (
          !response.competentTaxOffice &&
          taxOfficeData.value.length > 0
        ) {
          selectOfficeByName(taxOfficeData.value[0].prefectureCode, "");
        } else {
          selectOfficeByName("01", "");
        }
      } else {
        // エラー表示  TODO
        errors.value.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }
    })
    .finally(() => {
      commit("businessModule/processDialogue", false);
    });
};
// #endregion

// **********************************************
//画面初期化
// **********************************************
const prefectureSelect = ref(null);
watch(isShow, (newVal) => {
  if (newVal) {
    // エラーメッセージ初期化
    errors.value = [];
    // 検索キー初期化
    searchKey.value = "";
    // 初期フォーカス設定(事業者コード)
    nextTick(() => {
      prefectureSelect.value.focus();
    });
    // エラーメッセージを初期化
    commit("securityModule/updateErrors", []);
    getList();
  }
});
// **********************************************
//画面間のデータの受け渡し
// **********************************************
watch(
  () => props.modelValue,
  () => {
    inputTaxOfficeName.value = props.modelValue;
  }
);
// **********************************************
//入力した値のバインド
// **********************************************
const inputValChange = (e) => {
  emit("update:modelValue", e);
};

//#region チェック関連
// 所轄税務署
const validate = () => {
  //エラー表示の初期化
  errorStyleInit();
  // 入力禁止文字チェック(所轄税務署)
  if (inputTaxOfficeName.value !== "") {
    if (!Validation.checkNationalkinsokuchar(inputTaxOfficeName.value)) {
      errorData.isErrorCompetentTaxOffice = true;
      if (
        !errorData.errors_CompetentTaxOffice ||
        errorData.errors_CompetentTaxOffice.length == 0
      ) {
        errorData.errors_CompetentTaxOffice.push(
          Common.createError(
            "MTCL1098",
            Common.getMessage("MTCL1098", ["所轄税務署"])
          )
        );
      }
      return false;
    } else {
      return true;
    }
  }
  return true;
};
defineExpose({ validate });

const showModal = () => {
  isShow.value = true;
};

// エラースタイルを初期化する
const errorStyleInit = () => {
  errorData.isErrorCompetentTaxOffice = false;
  errorData.errors_CompetentTaxOffice = [];
};
</script>
<style scoped>
.popup .swap-row .table-select td {
  height: 60px;
}
.popup .swap-row .frm-row{
  justify-content: flex-start;
}
.popup .frm-row:first-child {
  margin-top: 20px !important;
}
</style>
